import {ENTERPRISE} from 'Constants/ActionTypes';

const {GET_COMPANY_INFO_LIST, SET_COMPANY_INFO_CONFIG_MODAL_DATA} = ENTERPRISE;

const initialState = {
  tableListData: [], // table数据
  configModalData: {
    vccId: '',
    projectNum: '',
    transferNumbers: '',
    callTimeOut: '',
    callbackUrl: '',
    appId: '',
    appSecret: '',
  }, // 配置弹框的数据
};

const companyInfo = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_COMPANY_INFO_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: action.payload.data || [],
      };
    case `${GET_COMPANY_INFO_LIST}_FAIL`:
      return {
        ...state,
        tableListData: [],
      };
    case `${SET_COMPANY_INFO_CONFIG_MODAL_DATA}`:
      return {
        ...state,
        configModalData: action.data,
      };
    default:
      return state;
  }
};
export default companyInfo;
